export const GET_OTP_CODE_API_ENDPOINT = '/booking-portal/OTP/GetOTP';
